<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 客户表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="formData.creater_id === operator_id || editable === '是'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="editMainHandler"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="editMainHandler"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="saveHandler"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
            <el-row>
              <el-col :span="6">
                <el-form-item label="客户名称" :rules="[{ required: true}]">
                  <el-input v-if="formStatus" placeholder="客户名称" v-model="formData.name"></el-input>
                  <span v-else>{{formData.name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="客户编码">
                  <el-input v-if="formStatus" placeholder="客户编码" v-model="formData.code"></el-input>
                  <span v-else>{{formData.code}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开户行">
                  <el-input v-if="formStatus" placeholder="开户行" v-model="formData.opening_bank"></el-input>
                  <span v-else>{{formData.opening_bank}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="银行账户">
                  <el-input v-if="formStatus" placeholder="银行账户" v-model="formData.bank_account"></el-input>
                  <span v-else>{{formData.bank_account}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="所在地区">
                  <template v-if="formStatus">
                    <el-select size="mini" v-model="formData.province_code" placeholder="省" style="width: 33.3%" v-on:change="handlerSelectProvince">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in provinces" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formData.city_code" placeholder="市" style="width: 33.3%" v-on:change="handlerSelectCity">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in cities" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formData.district_code" placeholder="区" style="width: 33.3%" v-on:change="handlerSelectDistrict">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in districts" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </template>
                  <span v-else>{{formData.province + formData.city + formData.district}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="公司地址">
                  <el-input v-if="formStatus" placeholder="公司地址" v-model="formData.address"></el-input>
                  <span v-else>{{formData.address}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                  <span v-else>{{formData.remark}}</span>
                </el-form-item>
              </el-col>
            </el-row>
        </div>
        <div class="detail-header">
          <div class="detail-title"><i class="em-icon-th-list"></i> 联系人信息</div>
          <el-button v-if="formStatus" type="warning" size="mini" icon="el-icon-plus" @click="handlerAddDetails">新增联系人</el-button>
        </div>
        <div class="el-table-container form-details" style="top: 104px;">
          <el-table :data="formData.contacters" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="handleSelectionChange">
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="姓名" prop="name" width="80" align="center">
              <template v-slot:default="scope">
                <el-input size="mini" v-if="formStatus" placeholder="姓名" v-model="scope.row.name"></el-input>
                <span v-else>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="职务" prop="position" width="80" align="center">
              <template v-slot:default="scope">
                <el-input size="mini" v-if="formStatus" placeholder="职务" v-model="scope.row.position"></el-input>
                <span v-else>{{scope.row.position}}</span>
              </template>
            </el-table-column>
            <el-table-column label="性别" prop="gender" width="60" align="center">
              <template v-slot:default="scope">
                <el-select size="mini" v-if="formStatus" v-model="scope.row.gender" placeholder="性别">
                  <el-option v-for="item in genders" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                </el-select>
                <span v-else>{{scope.row.gender}}</span>
              </template>
            </el-table-column>
            <el-table-column label="电话" prop="phone" width="150" align="center">
              <template v-slot:default="scope">
                <el-input size="mini" v-if="formStatus" placeholder="电话" v-model="scope.row.phone"></el-input>
                <span v-else>{{scope.row.phone}}</span>
              </template>
            </el-table-column>
            <el-table-column label="电子邮箱" prop="email" width="300" align="center">
              <template v-slot:default="scope">
                <el-input size="mini" v-if="formStatus" placeholder="电子邮箱" v-model="scope.row.email"></el-input>
                <span v-else>{{scope.row.email}}</span>
              </template>
            </el-table-column>
            <el-table-column label="主要联系人" prop="is_main" width="70" align="center">
              <template v-slot:default="scope">
                <el-select size="mini" v-if="formStatus" v-model="scope.row.is_main" placeholder="主要联系人">
                  <el-option v-for="item in yesOrNo" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                </el-select>
                <span v-else>{{scope.row.is_main}}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" header-align="center">
              <template v-slot:default="scope">
                <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                <span v-else>{{scope.row.remark}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="50" align="center">
              <template v-slot:default="scope">
                <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetail(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater}}</span>
          <span>制单日期：{{formData.create_time}}</span>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<style>
.ezz-tab-pane-header{
  position: absolute;
  top: 0;
  right: 5px;
  left: 5px;
  height: 30px;
  padding-top: 5px;
}
.ezz-tab-pane-body{
  position: absolute;
  top: 35px;
  right: 5px;
  bottom: 0;
  left: 5px;
}
/**********************/
.my-autocomplete li{
    line-height: normal;
    padding: 7px;
}
.customer-name,
.leader-name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.customer-code,
.leader-code {
  font-size: 12px !important;
  color: #b4b4b4;
}

.highlighted .customer-code {
  color: #ddd;
}
.autocom {
  margin-left: -80px;
}
</style>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        code: '',
        name: '',
        short_name: '',
        province_code: '',
        province: '',
        city_code: '',
        city: '',
        district_code: '',
        district: '',
        address: '',
        opening_bank: '',
        bank_account: '',
        remark: '',
        contacters: [],
        creater: '',
        creater_id: ''
      },
      formDetailEmptyData: {
        id: '',
        customer_id: '',
        name: '',
        position: '',
        gender: '男',
        phone: '',
        email: '',
        sort: '',
        is_main: '否',
        remark: ''
      },
      // 是否
      genders: [
        { label: '男' },
        { label: '女' }
      ],
      // 是否
      yesOrNo: [
        { label: '是' },
        { label: '否' }
      ],
      provinces: this.$region.getProvinces(),
      cities: [],
      districts: [],
      selectedContacters: [],
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      detailCurrentRowIndex: 0,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable
    }
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getCustomer, { ModelId: _this.formData.id }, function (res) {
        let _json = res.data
        let _formData = _json.customer
        if (_formData != null) {
          _this.formData = _formData
          if (_this.formData.province_code !== null && _this.formData.province_code !== '') {
            _this.cities = _this.$region.getCities(_this.formData.province_code)
          }
          if (_this.formData.city_code !== null && _this.formData.city_code !== '') {
            _this.districts = _this.$region.getDistricts(_this.formData.city_code)
          }
        } else {
          _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          _this.formData.creater_id = _this.operator_id
        }
      })
    },
    /*
     * 选择省份，获取城市
     */
    handlerSelectProvince: function () {
      var _this = this
      var _provinceCode = _this.formData.province_code
      var _province = _this.provinces.find(function (item) {
        return item.code === _provinceCode
      })
      _this.formData.province = _province.name
      _this.cities = _this.$region.getCities(_provinceCode)
      if (_this.cities.length === 0) {
        // 清空城市数据
        _this.formData.city_code = ''
        _this.formData.city = ''
        _this.cities = []
        // 清空行政区数据
        _this.formData.district_code = ''
        _this.formData.district = ''
        _this.districts = []
      } else {
        _this.formData.city_code = _this.cities[0].code
        _this.formData.city = _this.cities[0].name
        _this.handlerSelectCity()
      }
    },

    /*
     * 选择城市，获取行政区
     */
    handlerSelectCity: function () {
      var _this = this
      var _cityCode = _this.formData.city_code
      var _city = _this.cities.find(function (item) {
        return item.code === _cityCode
      })
      _this.formData.city = _city.name
      _this.districts = _this.$region.getDistricts(_cityCode)
      if (_this.districts.length === 0) {
        // 清空行政区数据
        _this.formData.district_code = ''
        _this.formData.district = ''
        _this.districts = []
      } else {
        _this.formData.district_code = _this.districts[0].code
        _this.formData.district = _this.districts[0].name
      }
    },

    /*
     * 选择行政区
     */
    handlerSelectDistrict: function () {
      var _this = this
      var _districtCode = _this.formData.district_code
      var _district = _this.districts.find(function (item) {
        return item.code === _districtCode
      })
      _this.formData.district = _district.name
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    addHandler: function () {
      this.formData.id = '0'
      this.isShow = true
      this.formStatus = true
      this.loadData()
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    editMainHandler: function () {
      this.formStatus = !this.formStatus
    },
    delDetail: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.contacters, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 新增联系人
    handlerAddDetails: function () {
      const _this = this
      const contacter = JSON.parse(JSON.stringify(_this.formDetailEmptyData))
      _this.formData.contacters.push(contacter)
    },
    // 删除联系人明细
    handlerDelDetail: function (_index) {
      let _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.formData.contacters.splice(_index, 1)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSelectionChange: function (_selection) {
      this.selectedContacters = _selection
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.name === '') {
          _this.$message({
            type: 'error',
            message: '部门名称不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    saveHandler: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveCustomer, _this.formData, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '保存成功',
              type: 'success'
            })
            _this.formData.id = _json.id
            _this.formStatus = false
            _this.parent.loadData()
          }
        })
      }
    }
  },
  components: {
  }
}
</script>
